import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnPlan extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public name: string;

  @Expose()
  public allowFususone: boolean;

  @Expose()
  public allowDeviceDefender: boolean;

  @Expose()
  public allowFususregistry: boolean;

  @Expose()
  public allowFususops: boolean;

  @Expose()
  public allowFususopsStream: boolean;

  @Expose()
  public allowFususalert: boolean;

  @Expose()
  public allowFususvault: boolean;

  @Expose()
  public allowFusustips: boolean;

  @Expose()
  public allowFususalertAmber: boolean;

  @Expose()
  public allowFususmeet: boolean;

  @Expose()
  public allowComms: boolean;

  @Expose()
  public allowLiveViewRecord: boolean;

  @Expose()
  public allowFloorPlan: boolean;

  // Should this be a boolean? It comes back as a number from the API
  @Expose()
  public maxCameras: boolean;

  @Expose()
  public isLawEnforcementPlan: boolean;

  @Expose()
  public allowTrackBreadcrumbs: boolean;

  @Expose()
  public allowLocationTracking: boolean;

  @Expose()
  public allowFususnotify: boolean;

  @Expose()
  public allowAi: boolean;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
